import React, { useState } from 'react';
import Helmet from 'react-helmet';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Select from 'components/form/Select';
import {API} from "aws-amplify";
import SupplementalEssays from './components/SupplementalEssays';
import PersonalStatements from './components/PersonalStatements';

const EssaysSummary = () => {
  const [selected, setSelected] = useState('');
  const [tab, setTab] = useState(0);

  const loadOptions = (query, loadedOptions, { page }) => {
    return API.get('api', '/college/search', {
      queryStringParameters: {
        name: query,
        fields: 'id,school.name',
        per_page: 10,
        page,
      },
    }).then((resp) => {
      let options = resp.results.map((i) => ({
        label: i['school.name'],
        value: i.id,
      }));
      return {
        options,
        hasMore: Math.ceil(resp.metadata.total / resp.metadata.per_page) > page,
        additional: {
          page: page + 1,
        },
      };
    });
  };

  const onChange = (val) => {
    setSelected(val);
  };

  return (
    <Box>
      <Helmet title="Essays Summary" />
      <Select
        async
        paginate
        debounceTimeout={300}
        cacheOptions
        defaultOptions
        isMulti={false}
        loadOptions={loadOptions}
        onChange={onChange}
        additional={{
          page: 0,
        }}
        value={selected}
        placeholder="Start typing university name"
      />
      <Box>
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="Personal Statements" />
          <Tab label="Supplemental Essays" />
        </Tabs>
        <Box mt={2}>
          {tab === 0 && <PersonalStatements school={selected} />}
          {tab === 1 && <SupplementalEssays school={selected} />}
        </Box>
      </Box>
    </Box>
  );
};

export default EssaysSummary;